// removed by extract-text-webpack-plugin
module.exports = {"heading":"AuthConfirmationMessage-hashed__heading__325Vw","footerWrapper":"AuthConfirmationMessage-hashed__footerWrapper__3OR6k","infoMessage":"AuthConfirmationMessage-hashed__infoMessage__1Widv"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/common/AuthConfirmationMessage/AuthConfirmationMessage-hashed.scss
// module id = 1158
// module chunks = 0